import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PhotoService} from '../../../modules/photo/services/photo.service';
import {ToastrService} from 'ngx-toastr';
import {SearchService} from '../../../modules/search/services/search.service';
import {Photo} from '../../models/cameralla-photo.model';

@Component({
    selector: 'app-success-page',
    templateUrl: './success-page.component.html',
})
export class SuccessPageComponent implements OnInit, OnDestroy {
    photo: Photo;
    photoId;
    private sub: any;
    photosSuggestion: Photo[] = [];
    action;
    announcement;
    suggestTags = [];
    tagPromises = [];
    photosByUser = [];
    index = 0;
    constructor(private route: ActivatedRoute,
                private photoService: PhotoService,
                private toastr: ToastrService,
                private searchService: SearchService) {
        this.photo = new Photo();
        this.action = this.route.snapshot.paramMap.get('action');
    }

    ngOnInit() {
        this.photosSuggestion = [];
        this.sub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.photoId = params['id'];
                this.photoService.getPhotoDetails(params['id'], false).then(
                    response => {
                        this.photo = response['Data'];

                        if (this.action === 'review') {
                            this.announcement = `Success! You\'re just left a review for ${this.photo.customer.fullName}\'s photo.`;
                        }

                        if (this.action === 'uploaded') {
                            this.announcement = 'Success! You\'re uploaded a new photo.';
                        }

                        this.photoService.getPhotosByUserId(response['Data']['customerId'], this.photoId).toPromise().then(
                            result => this.photosByUser = result['Data']
                        );

                        this.getTags(response['Data']['tags']);
                    }
                );
            } else {
                this.toastr.error('Photo ID missing!', 'Something wrong');
            }
        });
    }

    getTags(tagString) {
        tagString.split(',').map(item => {
            if (item !== '') {
                this.suggestTags.push(item.replace(/[^\w\s]/gi, ''));
            }
        });

        if (this.suggestTags.length) {
            this.suggestTags.forEach(
                tag => {
                    this.tagPromises.push(this.suggestPhotoPromise(tag));
                }
            );

            Promise.all(this.tagPromises).then(
                arr => {
                    arr.forEach(
                        item => {
                            item['Data']['photos'].forEach(
                                (photo: Photo) => {
                                    if (photo.id.toString() !== this.photoId) {
                                        if (!this.photosSuggestion.some(el => el.id === photo.id)) {
                                            this.photosSuggestion.push(photo);
                                        }
                                    }
                                }
                            );
                        }
                    );
                    this.photosSuggestion = this.photosSuggestion.sort(this.compareFn);
                }
            );
        }
    }

    suggestPhotoPromise(tag) {
        return this.searchService.searchPhotosByTag(tag).toPromise();
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    compareFn(a, b) {
        return (a.create_at < b.create_at) ? 1 : ((a.create_at > b.create_at) ? -1 : 0);
    }
}
